module.exports = __webpack_public_path__ + "media/app/assets/specializations/rogue/outlaw-7b0aa56fe9f41cd2767685236fad4d3d.png";